import InfoRounded from '@mui/icons-material/InfoRounded';
import { styled } from '@mui/material/styles';

export const StyledInfoIcon = styled(InfoRounded)`
  transform: translateY(${({ theme }) => theme.spacing(0.6)});
  color: ${({ theme }) => theme.palette.text.secondary};
  width: ${({ theme }) => theme.spacing(2.5)};
  height: ${({ theme }) => theme.spacing(2.5)};
  margin-left: ${({ theme }) => theme.spacing(0.5)};
`;
